import React, { useCallback } from 'react';
import Button from '@mui/material/Button';

const AddButton = props => {
  const { selectedImage } = props;

  const handleAddClick = useCallback(() => {
    window.handleSelectedValue?.(selectedImage);
  }, [selectedImage]);

  return (
    <Button variant="contained" color="secondary" onClick={handleAddClick}>
      Add
    </Button>
  );
};

export default AddButton;
